import { render, staticRenderFns } from "./Players.vue?vue&type=template&id=1140a062&scoped=true&"
import script from "./Players.vue?vue&type=script&lang=js&"
export * from "./Players.vue?vue&type=script&lang=js&"
import style0 from "./Players.vue?vue&type=style&index=0&id=1140a062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1140a062",
  null
  
)

export default component.exports